<template>
    <div>
        <div class="booking-section sdr-box" style="padding:0px; padding-top: 10px;" v-for="(item, index) in get_RebookingTickets({ idFlight: flight.idFlight, whichCall: whichcall })" v-bind:key="index">
            <!-- >>> 'Pax Headline Rebooking, Mode: 'overview' -->
            <h4 class="paxheadline" v-if="mode !=='rebookingpassengers'" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                {{ trnslPaxSalutations(item.pax.salutation) }} {{ item.pax.firstName }} {{ item.pax.lastName }} ({{ born[getCurrentLocale] }}: {{ item.pax.birthdate | birthdate }})
            </h4>

            <!-- >>> 'Pax Headline Rebooking, Mode: 'rebookingpassengers' -->
            <div class="outerbox" v-if="mode ==='rebookingpassengers'">
                <div class="mybox">
                    <input type="checkbox"
                    :disabled="flight.rebookable === false"
                    :id="'singlePax_' + flight.idFlight + '_' + item.pax.idPax + '_' + flightdirection + '_' + item.pax.salutation + '_' + item.ticket.idTicket"
                    :name="'singlePax_' + flight.idFlight + '_' + item.pax.idPax + '_' + flightdirection + '_' + item.pax.salutation + '_' + item.ticket.idTicket"
                    :checked="get_RebookingAllPaxCheckboxClicked.includes(String(flightdirection)) && flight.rebookable === true">
                </div>
                <div class="mybox">
                    <h4 class="paxheadline" style="margin-bottom: 0px;" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                        {{ trnslPaxSalutations(item.pax.salutation) }} {{ item.pax.firstName }} {{ item.pax.lastName }} ({{ born[getCurrentLocale] }}: {{ item.pax.birthdate | birthdate }})
                    </h4>
                </div>
            </div>


            <!-- >>> 'Pax Table Services' -->
            <div class="table-cell cruise-itinerary" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                <div class="sdr-box" style="padding-top: 0px; padding-bottom:30px; padding-left: 0px; padding-right: 0px;">
                    <table >
                        <tbody>
                            <!-- flight  -->
                            <tr v-if="whichcall === 'getbooking'">
                                <td>{{ flightpriceservices[getCurrentLocale] }}</td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small"> - </td>
                            </tr>

                            <!-- rebookingprice  -->
                            <tr v-if="whichcall === 'getrebookingkey'">
                                <td><b>{{ flightpricedifference[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ item.ticket.rebookingPrice !== undefined ? item.ticket.rebookingPrice : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- rebooking fee  -->
                            <tr>
                                <td><b>{{ rebookingfee[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ getRebookingOriginalBookingRebookingFee | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- seat  -->
                            <tr v-if="item.ticket.seatServices.length > 0">
                                <td>
                                    {{ seat[getCurrentLocale] }}: <b>{{ item.ticket.seatServices[0].seatIdentifyer.number + '' + item.ticket.seatServices[0].seatIdentifyer.letter| truncate(17, '...') }}</b>
                                    <span style="color: red;" v-if="whichcall === 'getrebookingkey' && item.ticket.seatServices[0].status !== 'CONFIRMED'">&nbsp;&nbsp;({{ seatnotrebookable[getCurrentLocale] }})</span>
                                </td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ item.ticket.seatServices[0].price !== undefined ? item.ticket.seatServices[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- infant  -->
                            <tr v-if="item.ticket.infantServices.length > 0">
                                <td>{{ infant[getCurrentLocale] }}: <b>({{ item.ticket.infantServices[0].firstName + ' ' + item.ticket.infantServices[0].lastName | truncate(27, '...') }})</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ item.ticket.infantServices[0].price !== undefined ? item.ticket.infantServices[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- services -->
                            <tr v-for="(srvcs, index) in item.ticket.services" v-bind:key="index">
                                <td>{{ srvcs.description }} <b>({{ paid[getCurrentLocale] }})</b></td>
                                <td style="text-transform: none;"><span v-if="srvcs.quantity > 1">{{ srvcs.quantity }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'flight', 'flightdirection', 'mode', 'whichcall'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                flightpriceservices: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                flightpricedifference: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                paid: {
                    en: 'paid',
                    de: 'bezahlt'
                },
                // >>> --------------------------
                rebookingfee: {
                    en: 'Rebooking fee',
                    de: 'Umbuchungsgebühr',
                },
                flightpricedifference: {
                    en: 'Price difference flight',
                    de: 'Preisdifferenz Flug',
                },
                seatnotrebookable: {
                    en: 'Attention: This seat cannot be rebooked!',
                    de: 'Achtung: Dieser Sitz kann nicht umgebucht werden!'
                }
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_RebookingTickets',
                'get_RebookingAllPaxCheckboxClicked',
                'getRebookingOriginalBookingRebookingFee',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),


            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * trnslPaxSalutations()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxSalutations: function(type) {

                var me = this,
                    trnsltdSalutation = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxSalutations');
                switch(type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
                }


                return trnsltdSalutation;

            }, // eof trnslPaxSalutations()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .flightIsNotRebookable {
        opacity: 0.3;
    }


    /* Price Table */
    .cruise-itinerary td {
        line-height: 1.8em;
        border: 1px solid #f5f5f5;
    }


    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }

    .outerbox {
        width: 100%;
        background-color: #f5f5f5;
        padding: 5px;
        height: 40px;
    }

    .mybox {
        float: left;
        background-color: #f5f5f5;
        padding: 5px;
    }


    input[type=checkbox] {
        transform: scale(1.2);
    }
</style>



// WEBPACK FOOTER //
// src/components/rebooking/pagecontent/BookingnoPaxDetails.vue